import { createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';
import { retailAction } from '@msdyn365-commerce/retail-proxy';
import { IArticle } from './DataServiceEntities.g';
import { createGetArticleByURLInput } from './DataActionExtension.g';

/**
 * Extracts the URL-decoded article slug from the last non-empty segment of the request path,
 * so slugs containing encoded characters (e.g. æ/ø/å, spaces) match the stored article URL.
 * @param pathname - The request path.
 * @returns The decoded slug, or an empty string when none is present.
 */
const getArticleSlug = (pathname: string): string => {
    const segments = pathname.split('/').filter(segment => segment.length > 0);
    const slug = segments[segments.length - 1] ?? '';
    try {
        return decodeURIComponent(slug);
    } catch {
        // Malformed URI sequence — fall back to the raw slug.
        return slug;
    }
};

export default createObservableDataAction({
    id: 'lobas-article/get-article-by-url',
    action: <IAction<IArticle>>retailAction,
    input: (context: ICreateActionContext) => createGetArticleByURLInput(getArticleSlug(context.requestContext.url.requestUrl.pathname))
});
